import Spinner from 'react-bootstrap/Spinner';
import { useNavigate } from 'react-router-dom';

export default function PageLoader(): JSX.Element {
  const navigate = useNavigate();

  return (
    <>
      <div className='header bg-base text-light d-flex'>
        <div onClick={() => navigate(-1)} className='p-1 px-md-2 d-flex align-items-center cup'>
          <span className='mdi mdi-36px mdi-chevron-right lh-1'></span>
        </div>
      </div>
      <div className='d-flex align-items-center justify-content-center py-5'>
        <Spinner animation='border' />
      </div>
    </>
  );
}
